import { render, staticRenderFns } from "./promote-order-import.vue?vue&type=template&id=9aae40c2&scoped=true&"
import script from "./promote-order-import.vue?vue&type=script&lang=js&"
export * from "./promote-order-import.vue?vue&type=script&lang=js&"
import style0 from "./promote-order-import.vue?vue&type=style&index=0&id=9aae40c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aae40c2",
  null
  
)

export default component.exports